import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CardTransfers icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CardTransfers } from '@sravni/design-system-icons'
 *
 * <CardTransfers />
 * ```
 */
var CardTransfers = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CardTransfers", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.236 8.333h15M10.736 14.583l1.25 1.25M10.736 17.083l1.25-1.25M10.736 5.417l-1.25-1.25M10.736 2.917l-1.25 1.25M11.986 15.833H4.903c-.92 0-1.667-.745-1.667-1.666V5.833c0-.92.746-1.666 1.667-1.666H6.57M9.486 4.167h7.084c.92 0 1.666.746 1.666 1.666v8.334c0 .92-.745 1.666-1.666 1.666h-1.667", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CardTransfers };
//# sourceMappingURL=CardTransfers.js.map
